import { Shield, ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    body: "Il titolare del trattamento dei dati è il salone Barber Latin. Per qualsiasi domanda sulla privacy puoi contattarci su WhatsApp tramite il pulsante presente nell'app oppure via email: jordan.felipito89@gmail.com.",
  },
  {
    title: "2. Dati che raccogliamo",
    body: "Quando prenoti un appuntamento (tramite l'assistente Jordan o il modulo di prenotazione rapida) raccogliamo: nome, numero di telefono WhatsApp, servizio scelto, data e ora dell'appuntamento. L'indirizzo email è facoltativo. Se sei un barbiere partner, raccogliamo anche il nome del tuo salone e i dati di pagamento della quota mensile.",
  },
  {
    title: "3. Perché usiamo i tuoi dati",
    body: "I dati servono esclusivamente a: gestire la tua prenotazione, inviarti la conferma e gli aggiornamenti su WhatsApp, sincronizzare l'agenda del salone e contattarti in caso di cambiamenti o disponibilità in lista d'attesa. Non vendiamo né cediamo i tuoi dati a terzi per scopi di marketing.",
  },
  {
    title: "4. Servizi di terze parti",
    body: "L'app utilizza: Google Calendar (solo per l'agenda del titolare, dove vengono create le voci delle prenotazioni), WhatsApp/CallMeBot (per l'invio delle notifiche), SumUp (per i pagamenti, gestiti interamente sul sito di SumUp) e Amazon (link affiliato: gli acquisti avvengono sul sito di Amazon secondo la sua privacy policy). Ogni servizio applica la propria informativa privacy.",
  },
  {
    title: "5. Agenda condivisa e inventario",
    body: "Il titolare può condividere un link di sola lettura dell'agenda (senza numeri di telefono dei clienti) con i suoi collaboratori o socio. L'inventario dei prodotti da comprare è visibile solo nell'area riservata e non contiene dati personali.",
  },
  {
    title: "6. Conservazione e cancellazione",
    body: "Le prenotazioni vengono conservate per la gestione dell'agenda e dello storico clienti. I dati tecnici restano nel tuo dispositivo (localStorage) e puoi eliminarli cancellando i dati del sito dal browser. Puoi chiedere in qualsiasi momento la rettifica o la cancellazione dei tuoi dati scrivendoci su WhatsApp.",
  },
  {
    title: "7. I tuoi diritti (GDPR)",
    body: "Ai sensi del Regolamento (UE) 2016/679 hai diritto di accesso, rettifica, cancellazione, limitazione e opposizione al trattamento dei tuoi dati. Per esercitarli basta un messaggio WhatsApp al salone: rispondiamo rapidamente.",
  },
  {
    title: "8. Cookie e dati locali",
    body: "L'app non usa cookie pubblicitari né di profilazione. Utilizza solo cookie tecnici di sessione per l'area riservata e il localStorage del browser per ricordare le tue preferenze (nome e telefono per prenotare più in fretta).",
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="page-privacy" className="min-h-[100dvh] bg-zinc-950 text-white">
      <div className="mx-auto flex min-h-[100dvh] w-full max-w-md flex-col gap-6 px-6 py-8">
        <a
          data-testid="privacy-back"
          href="/"
          className="flex w-fit items-center gap-2 text-xs font-semibold uppercase tracking-widest text-zinc-500 transition-colors hover:text-amber-400"
        >
          <ArrowLeft size={14} /> Torna all&apos;app
        </a>
        <header className="flex items-start gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-400/15 text-amber-400">
            <Shield size={20} />
          </span>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-zinc-600">
              Barber Latin
            </p>
            <h1 className="font-display text-3xl font-bold text-white">Privacy Policy</h1>
            <p className="mt-1 text-xs text-zinc-500">Ultimo aggiornamento: settembre 2026</p>
          </div>
        </header>
        <p className="text-sm leading-relaxed text-zinc-300">
          La tua privacy è importante. Questa pagina spiega in modo semplice quali dati raccoglie
          l&apos;app, perché li usa e quali diritti hai.
        </p>
        {SECTIONS.map((s) => (
          <section
            key={s.title}
            data-testid={`privacy-section-${s.title.slice(0, 1)}`}
            className="flex flex-col gap-2 rounded-2xl border border-white/10 bg-zinc-900 p-5"
          >
            <h2 className="text-base font-bold text-white md:text-lg">{s.title}</h2>
            <p className="text-sm leading-relaxed text-zinc-400">{s.body}</p>
          </section>
        ))}
        <p className="pb-6 text-center text-[11px] text-zinc-600">
          Barber Latin — Prenotazioni, prodotti e contatti del salone.
        </p>
      </div>
    </div>
  );
}
